module.exports = __webpack_public_path__ + "img/education.5825ba92.jpg";